import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { HomeOutlined, LogoutOutlined, SwapOutlined } from "@ant-design/icons";
import { Button, Dropdown, Menu, Tooltip } from "antd";
import MenuUnfoldOutlined from "@ant-design/icons/MenuUnfoldOutlined";
import MenuFoldOutlined from "@ant-design/icons/MenuFoldOutlined";
import { useKeycloak } from "@react-keycloak/web";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./SideMenu.scss";
import StoreModal from "../components/storeModal";
import { fetchId, reset, setDefaultStoreId } from "../store/rootStore";
import { FaHome } from "react-icons/fa";
import { ENV } from "../config";
import { decrypt, encrypt } from "../utility";

const Header = ({
  collapsed,
  setCollapsed,
  setResMenuToggle,
  resMenuToggle,
}) => {
  const user = useSelector((state) => state.rootStore.user);
  const storeLength = useSelector((state) => state.rootStore.storeLength);
  let storesName = useSelector((state) => state.rootStore.storeName);
  const role = useSelector((state) => state.rootStore.userRole);
  const storeList = useSelector((state) => state.rootStore.storeList);
  const paramsId = useSelector((state) => state.rootStore.paramsId);

  const [visible, setVisible] = useState(false);
  const [store, setStore] = useState([]);

  const dispatch = useDispatch();
  const location = useLocation();

  const { keycloak } = useKeycloak();


  const navigate = useNavigate();

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  // toggle responsive menu state with smooth transition
  const toggleResponsiveMenu = () => {
    setResMenuToggle(!resMenuToggle);
    // When on mobile, this only affects the overlay menu
    // On desktop screens, we want to toggle the collapsed state
    if (window.innerWidth >= 1280) {
      // xl breakpoint
      setCollapsed(!collapsed);
    }
  };

  const handleLogout = async () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const encryptedStore = params.get("store");
      let storeIdToSet = paramsId;
      if (encryptedStore) {
        try {
          const decoded = decodeURIComponent(encryptedStore);
          storeIdToSet = await decrypt(decoded);
        } catch (e) {
          // fall back to existing paramsId on decryption failure
          storeIdToSet = paramsId;
        }
      }

      localStorage.clear();
      dispatch(reset());
      if (storeIdToSet) {
        dispatch(setDefaultStoreId(storeIdToSet));
      }
      await keycloak.logout({ redirectUri: ENV.HOME_URL });
      // await keycloak.logout();
    } catch (e) {
      // As a fallback, force navigation home
      window.location.href = ENV.HOME_URL;
    }
  };

  const selectStore = async (item) => {
    if (item && dispatch(fetchId({ item: item }))) {
      // Update URL with encrypted store id
      try {
        const encrypted = await encrypt(String(item.store_id));
        const url = new URL(window.location.href);
        url.searchParams.set("store", encodeURIComponent(encrypted));
        window.history.replaceState(null, "", url.toString());
      } catch (e) {
        // ignore URL update failures
      }
      if (location.pathname == "/") {
        navigate("/");
      } else if (location.pathname == "/incoming-transfer") {
        navigate("/incoming-transfer");
      } else if (location.pathname == "/outgoing-transfer") {
        navigate("/outgoing-transfer");
      } else if (location.pathname == "/imports") {
        navigate("/imports");
      } else if (location.pathname == "/stock-analysis") {
        navigate("/stock-analysis");
      } else {
        navigate("/stock-movement");
      }
      setVisible(false);
    }
  };

  const handleCancel = () => {
    setVisible(false);
  };
  const goHome = () => {
    // window.location.replace(url); // navigate back to POS
    dispatch(reset());
    window.location.href = ENV.HOME_URL;
    // await keycloak.logout();
  };

  const menu = (
    <Menu className="min-w-[100px] rounded px-[6px] py-[8px]">
      {storeLength > 1 && (
        <Menu.Item key="1">
          <span
            onClick={() => {
              setVisible(true);
              setStore(storeList);
            }}
          >
            <SwapOutlined
              style={{ marginRight: "10px" }}
              onClick={() => {
                setVisible(true);
                setStore(storeList);
              }}
            />{" "}
            Switch Store
          </span>
        </Menu.Item>
      )}
      <Menu.Item key="2">
        <HomeOutlined style={{ marginRight: "10px" }} onClick={goHome} />{" "}
        <span onClick={() => goHome()}>Back to Home</span>
      </Menu.Item>
      <Menu.Item key="3">
        <LogoutOutlined style={{ marginRight: "10px" }} />
        <span onClick={() => handleLogout()}>Log Out</span>
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="relative p-1 text-white bg-primary sm:rounded-2xl sm:p-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {/* Left Section */}
          <button
            type="button"
            onClick={toggleResponsiveMenu}
            className="flex items-center justify-center w-10 h-10 text-2xl transition-transform duration-300 xl:hidden hover:scale-110"
          >
            {resMenuToggle ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
          </button>
          <Link
            // to={"/"}
            className={`inline-block xl:ml-20 transition-all duration-200 ${collapsed ? "ml-10" : ""
              }`}
            onClick={goHome}
          >
            <img
              src="/images/Ocelot-Link-White-Logo.png"
              className={`transition-all duration-200 ${collapsed ? "h-8" : "xl:h-12 sm:h-10 h-8"
                } w-auto`}
              alt=""
            />
          </Link>
          <button
            type="button"
            onClick={toggleCollapsed}
            className="absolute hidden text-xl transition-transform duration-300 2xl:text-2xl left-5 xl:inline-block hover:scale-110"
          >
            {React.createElement(
              collapsed ? MenuUnfoldOutlined : MenuFoldOutlined
            )}
          </button>
        </div>

        {/* Right Section */}
        <div className="flex items-center justify-end space-x-3">
          {/* Added pr-6 for right padding */}
          <div className="font-[800] text-[14px] capitalize text-white inline-block xl:-mt-5">
            {[
              "merchant",
              "agent",
              "super agent",
              "employee",
              "designbuild",
            ].includes(role) && storesName}
          </div>
          <Dropdown
            className="inline-block xl:-mt-5"
            overlay={menu}
            trigger={["click"]}
            placement="bottomRight"
          >
            <a onClick={(e) => e.preventDefault()}>
              <span className="!bg-white font-bold !text-primary !min-w-9 !min-h-8 inline-flex justify-center items-center rounded-full md:text-xs">
                {user?.profile?.first_name
                  ? user.profile.first_name.charAt(0).toUpperCase() +
                  user.profile.last_name.charAt(0).toUpperCase()
                  : "U"}
              </span>
            </a>
          </Dropdown>
        </div>
      </div>

      {visible && (
        <StoreModal
          visible={visible}
          handleCancel={handleCancel}
          store={store}
          handleOk={selectStore}
        />
      )}
    </div>
  );
};

export default Header;
